// @flow
import ko from 'rgs-knockout';
import _ from 'lodash';

import type {Observable, ObservableArray} from "rgs-knockout";

import {ISwitcherData} from './data-model';

export type SwitcherItem = {
	key: string,
	htmlContent: HTMLElement,
}

export type SwitcherArgs = {
	state: Observable<ISwitcherData>,
	onChange: (item: SwitcherItem) => void,
	view: 'full' | undefined,
};

export default class Switchers {

	// Model for binding within a template
	props: {
		items: ObservableArray<[]>,
		currentActiveIndex: Observable<number>,
		isItemActive: (index: number) => boolean,
		onItemClick: (index: number) => boolean,
	};

	// Occurs when the active item is changed
	onChange: (item: SwitcherItem, number) => void;

	constructor (options: SwitcherArgs) {

		// Initial props
		this.props = {
			items: ko.observableArray([]),
			currentActiveIndex: ko.observable(0),
			isItemActive: this.isItemActive,
			onItemClick: this.handleItemClick,
			view: options.view,
		};

		options.state.subscribe(state => {
			this._setProps(state);
		});

		this._setProps(options.state());

		// Occurs when the active item is changed
		this.onChange = options.onChange || _.noop;
	}

	_setProps (state: ISwitcherData) {
		this.props.items(state.items);
		this.props.currentActiveIndex(state.activeItemIndex);
	}

	isItemActive = (index: number): boolean => {
		return this.props.currentActiveIndex() === index;
	};

	handleItemClick = (index: number): boolean => {
		// Check if active item is changed
		if (index === this.props.currentActiveIndex()) {
			return;
		}

		this.props.currentActiveIndex(index);
		this.onChange(this.props.items()[index], index);

		return true;
	};
}
